import Device from 'constants/deviceSizes';
import { appConfig } from 'config/customization';

import { containerStyle } from '../../styles';

export default {
  container: {
    ...containerStyle
  },
  field: {
    marginBottom: 15,
    height: 70,
    minWidth: 300,
    width: appConfig.signUp.personalInformationFullWidthFields && '100%',
    [Device.tablet_mobile]: {
      width: '100%'
    }
  },
  signIn: {
    marginTop: 20,
    textDecoration: 'none'
  },
  captcha: {
    display: 'flex',
    justifyContent: 'flex-start',
    width: '100%',
    paddingTop: 13
  }
};
